import React from "react";
import GenericAdminCRUD from "../components/GenericAdminCRUD";

export default function ClientProductsEditor() {
  return (
    <GenericAdminCRUD
      title="Produtos Imobiliários"
      subtitle="Ficha técnica de cada empreendimento do cliente (VGV, tipologias, metragens, período, foto)."
      path="client-products"
      fields={[
        { key: "client_id", label: "Cliente *", type: "clientSelect" },
        { key: "name", label: "Nome do Empreendimento *", type: "text" },
        { key: "developer", label: "Incorporadora", type: "text" },
        { key: "type", label: "Tipo (Vertical, Horizontal, Loteamento…)", type: "text" },
        { key: "vgv", label: "VGV (ex: R$ 180.000.000)", type: "text" },
        { key: "typologies", label: "Tipologias", type: "text" },
        { key: "sizes", label: "Metragens", type: "text" },
        { key: "city", label: "Cidade/UF", type: "text" },
        { key: "period", label: "Período", type: "text" },
        { key: "photo", label: "Foto (URL)", type: "text", span: 2 },
        { key: "description", label: "Descrição", type: "textarea", span: 2 },
      ]}
      columns={[
        { key: "name", label: "Produto" },
        { key: "developer", label: "Incorporadora" },
        { key: "type", label: "Tipo" },
        { key: "vgv", label: "VGV" },
        { key: "city", label: "Cidade" },
        { key: "client_id", label: "Cliente", render: (it, { clients }) => clients.find((c) => c.id === it.client_id)?.company || "—" },
      ]}
    />
  );
}
